import { intervalWithTimeout } from './intervalWithTimeout';

const SATELLITE_RESOLVE_TIMEOUT = 10e3;
const SATELLITE_RESOLVE_INTERVAL = 100;

declare global {
  interface Window {
    _satellite: {
      getVar: (arg: string) => string | undefined;
    };
  }
}

export class Satellite {
  /**
   * Promise that resolves when the Satellite API is ready
   */
  public readonly resolved: Promise<boolean> = intervalWithTimeout(
    () => typeof window?._satellite?.getVar === 'function',
    SATELLITE_RESOLVE_INTERVAL,
    SATELLITE_RESOLVE_TIMEOUT,
  );

  constructor() {
    this.init();
  }

  private async init() {
    if (!(await this.resolved)) {
      console.warn(`Satellite not found on window`);
    }
  }

  /**
   * Get a stored value of an EVar variable.
   */
  public async getVar(name: string) {
    try {
      if (await this.resolved) {
        return window._satellite.getVar(name);
      }
    } catch (e) {
      console.warn(`Satellite getVar contained error`, e);
    }
  }
}

export const satellite = new Satellite();
